import { render, staticRenderFns } from "./SiderMenu.vue?vue&type=template&id=49ce5512&scoped=true"
import script from "./SiderMenu.vue?vue&type=script&lang=js"
export * from "./SiderMenu.vue?vue&type=script&lang=js"
import style0 from "./SiderMenu.vue?vue&type=style&index=0&id=49ce5512&prod&lang=scss&scoped=true"
import style1 from "./SiderMenu.vue?vue&type=style&index=1&id=49ce5512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce5512",
  null
  
)

export default component.exports